<template functional>
  <div>
    <ul v-if="props.items.length > 0">
      <li :key="index" v-for="(item, index) in props.items">
        <template v-if="props.component">
          <component :is="props.component" v-bind="{...item, ...props.data}" v-on="props.events" />
        </template>
        <template v-else>
          {{item}}
        </template>
      </li>
    </ul>
    <template v-else>
      -
    </template>
  </div>
</template>

<script>
export default {
  name: 'BaseList',

  props: {
    component: {
      type: [String, Object],
      default: null
    },
    items: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      default: () => {}
    },
    events: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
